<template>
  <div class="app-container">
    <BjRouteTabs :route-list="STOCK_DISTRIBUTION_ROUTE_LIST" />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockDistributionPlan.header.code')" prop="code">
            <BjInputCode
              v-model="queryParams.code"
              @keyup.enter.native="handleQuery"
              :placeholder="$t('BusinessStockDistributionPlan.header.code')"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="status">
            <BjSelectLov
              v-model="queryParams.status"
              :option-list="isVerify ? STOCK_DISTRIBUTE_PLAN_STATUS.slice(0, 2) : STOCK_DISTRIBUTE_PLAN_STATUS"
              :placeholder="$t('table.statusText')"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessStockDistributionPlan.header.receiveWarehouseIdList')" prop="receiveWarehouseIdList">
            <BjSelectWarehouse
              v-model="queryParams.receiveWarehouseIdList"
              multiple
              :type-code="['default-virtual', 'qty-virtual', 'interline-virtual']"
              :placeholder="$t('BusinessStockDistributionPlan.header.receiveWarehouseIdList')"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('form.startDateText')" prop="beginStartDate">
            <BjDateTimerangePicker v-model="queryParamsStartTime" :placeholder="$t('form.startDateText')"/>
          </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('form.endDateText')" prop="endStartDate">
            <BjDateTimerangePicker v-model="queryParamsEndTime" :placeholder="$t('form.endDateText')"/>
          </el-form-item
        ></el-col>
      </template>

      <template v-slot:tableOperation>
        <el-col>
          <el-button
            v-if="!isVerify"
            v-permission:BusinessStockDistributionPlanAdd
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('addText') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'status'">
                {{ STOCK_DISTRIBUTE_PLAN_STATUS.bjGet(scope.row[col.prop]) }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                v-permission="
                  !isVerify ? 'BusinessStockDistributionPlanView' : 'BusinessStockVerifyPlanView'
                "
                type="text"
                @click="onView(scope.row)"
                >{{ $t('viewText') }}</el-button
              >
              <template v-if="!isVerify" :text="$t('BusinessStockDistributionPlan.page')">
                <el-button
                  v-if="scope.row.status == 'wait'"
                  v-permission:BusinessStockDistributionPlanEdit
                  type="text"
                  :text="$t('BusinessStockDistributionPlan.pageText1')"
                  @click="onEdit(scope.row)"
                  >{{ $t('editText') }}</el-button
                >
                <el-button
                  v-if="['fail', 'cancel'].includes(scope.row.status)"
                  v-permission:BusinessStockDistributionPlanIndex_Reset
                  type="text"
                  :text="$t('BusinessStockDistributionPlan.pageText2')"
                  @click="onStatus('wait', scope.row)"
                  >{{ $t('resetText') }}</el-button
                >
                <el-button
                  v-if="scope.row.status == 'underway'"
                  v-permission:BusinessStockDistributionPlanIndex_Discard
                  type="text"
                  :text="$t('BusinessStockDistributionPlan.pageText3')"
                  @click="onStatus('abandon', scope.row)"
                  >{{ $t('BusinessStockDistributionPlan.btn') }}</el-button
                >
                <el-button
                  v-if="scope.row.status == 'wait'"
                  v-permission:BusinessStockDistributionPlanIndex_Cancel
                  type="text"
                  :text="$t('BusinessStockDistributionPlan.pageText4')"
                  @click="onStatus('cancel', scope.row)"
                  >{{ $t('cancelText') }}</el-button
                >
              </template>
              <template v-else>
                <!-- 有配置逻辑仓调拨需要审核时才有审核 -->
                <el-button
                  v-if="scope.row.status == 'wait'"
                  v-permission:BusinessStockVerifyPlanIndex_Pass
                  type="text"
                  class="main-btn"
                  @click="onAudit('pass', scope.row.id)"
                  >{{ $t('approvedText') }}</el-button
                >
                <el-button
                  v-if="scope.row.status == 'wait'"
                  v-permission:BusinessStockVerifyPlanIndex_Reject
                  type="text"
                  @click="onAudit('reject', scope.row.id)"
                  >{{ $t('auditRejectText') }}</el-button
                >
              </template>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { stockApi } from '@/api';
import { STOCK_DISTRIBUTION_ROUTE_LIST } from '@/utils/constants';
export default {
  name: 'BusinessStockDistributionPlanIndex',
  components: {},
  mixins: [pageMiXin],
  props: {
    /** 是否是审核页面 */
    isVerify: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      colSpan: 4,
      STOCK_DISTRIBUTION_ROUTE_LIST,
      queryApi: stockApi.getDistributePlansPage,
      selection: false,
      // 查询参数
      queryParams: {
        code: null,
        status: null,
        receiveWarehouseIdList: [],
        beginStartDate: null,
        endStartDate: null,
        beginEndDate: null,
        endEndDate: null,
        auditFlag: this.isVerify,
      },
      queryParamsStartTime: null,
      queryParamsEndTime: null,
      labelsVersion: 11,
      labelList: [
        { label: 'BusinessStockDistributionPlan.table.code', prop: 'code', isCheck: true, disabled: false, width: 135 },
        { label: 'BusinessStockDistributionPlan.table.receiveWarehouseName', prop: 'receiveWarehouseName', isCheck: true, disabled: false, width: 180 },
        { label: 'BusinessStockDistributionPlan.table.planNum', prop: 'planNum', isCheck: true, disabled: false, width: 180 },
        { label: 'BusinessStockDistributionPlan.table.alreadyNum', prop: 'alreadyNum', isCheck: true, disabled: false, width: 160 },
        { label: 'BusinessStockDistributionPlan.table.priorityGrade', prop: 'priorityGrade', isCheck: true, disabled: false },
        { label: 'form.startDateText', prop: 'startDate', isCheck: true, disabled: false, width: 135 },
        { label: 'form.endDateText', prop: 'endDate', isCheck: true, disabled: false, width: 135 },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false },
        { label: 'table.remarkText', prop: 'remark', isCheck: true, disabled: false },
        { label: 'table.creatorText', prop: 'createdName', isCheck: true, disabled: false, width: 135 },
        { label: 'table.createTimeText', prop: 'creationDate', isCheck: true, disabled: false, width: 135 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 165 },
      ],
    };
  },
  computed: {
    STOCK_DISTRIBUTE_PLAN_STATUS() {
      return this.$store.state.values['STOCK_DISTRIBUTE_PLAN_STATUS'] || [];
    },
  },
  watch: {
    queryParamsStartTime(v) {
      this.queryParams.beginStartDate = (v || [])[0];
      this.queryParams.endStartDate = (v || [])[1];
    },
    queryParamsEndTime(v) {
      this.queryParams.beginEndDate = (v || [])[0];
      this.queryParams.endEndDate = (v || [])[1];
    },
  },
  mounted() {
    this.$store.dispatch('values/getValueList', 'STOCK.DISTRIBUTE_PLAN_STATUS');
  },
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsStartTime = null;
      this.queryParamsEndTime = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    onStatus(flag, row) {
      let TEXT = this.STOCK_DISTRIBUTE_PLAN_STATUS.bjGet(flag);
      // TEXT = '重置';
      if (flag === 'wait') TEXT = this.$t('BusinessStockDistributionPlan.reset');
      this.$confirm(`${this.$t('toast.youAreTipText')} ${TEXT} ${this.$t('BusinessStockDistributionPlan.warehousePlan')}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi(row.id, flag);
        })
        .catch(() => {});
    },
    /** 审核 */
    onAudit(status, id) {
      this.$confirm(`是否审核${status === 'pass' ? '通过' : '不通过'}该数据？`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        stockApi
          .auditDistributePlan({
            id,
            status,
          })
          .then(res => {
            if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
          });
      });
    },
    /** 新建 */
    onAdd() {
      this.$toPage('BusinessStockDistributionPlanAdd');
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$toPage('BusinessStockDistributionPlanEdit', { id: row.id });
    },
    /** 查看 */
    onView(row) {
      this.$toPage(
        this.isVerify ? 'BusinessStockVerifyPlanView' : 'BusinessStockDistributionPlanView',
        {
          id: row.id,
          isVerify: this.isVerify,
        },
      );
    },
    operationApi(id, type) {
      let apiName = null;
      switch (type) {
        case 'wait':
          apiName = 'resetDistributePlan'; // 重置
          break;
        case 'abandon':
          apiName = 'invalidDistributePlan'; // 作废
          break;
        case 'cancel':
          apiName = 'cancelDistributePlan'; // 取消
          break;
      }
      stockApi[apiName]({ id }).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      stockApi.detailDistributePlans(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
</style>
